import { useState } from 'react';
import type { FormEvent } from 'react';
import { api, ApiError } from '../lib/api';

export default function NotifyPage() {
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');
  const [sending, setSending] = useState(false);
  const [feedback, setFeedback] = useState<{ kind: 'error' | 'success'; text: string } | null>(null);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!title.trim() || !body.trim()) {
      setFeedback({ kind: 'error', text: 'Título y mensaje son obligatorios' });
      return;
    }
    setSending(true);
    setFeedback(null);
    try {
      const res = await api.post<{ message?: string }>('/admin/notifications/send', {
        title: title.trim(),
        body: body.trim(),
      });
      setFeedback({ kind: 'success', text: res.message || 'Notificación enviada' });
      setTitle(''); setBody('');
    } catch (err) {
      setFeedback({ kind: 'error', text: err instanceof ApiError ? err.message : 'No se pudo enviar la notificación' });
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <h1 className="page-title">Enviar notificación push</h1>
      <p className="muted" style={{ marginBottom: 18 }}>
        Se enviará a todos los usuarios con notificaciones activas.
      </p>
      {feedback && (
        <div className={'alert ' + (feedback.kind === 'error' ? 'alert-error' : 'alert-success')}>
          {feedback.text}
        </div>
      )}
      <form className="card" onSubmit={onSubmit}>
        <div className="field">
          <label>Título *</label>
          <input required value={title} onChange={e => setTitle(e.target.value)} placeholder="Ej: Nueva reflexión disponible" />
        </div>
        <div className="field">
          <label>Mensaje *</label>
          <textarea required rows={4} value={body} onChange={e => setBody(e.target.value)} />
        </div>
        <button type="submit" className="btn" disabled={sending}>
          {sending ? 'Enviando…' : 'Enviar a todos'}
        </button>
      </form>
    </>
  );
}
